'use client';

import CTAButton from '@/components/common/CTAButton';
import { useLanguage } from '@/contexts/LanguageContext';

interface PriceItem {
  id: string;
  product: string;
  weight: string;
  purity: string;
  ankauf: string;
  verkaufNetto: string;
  verkaufBrutto: string;
  category: 'gold' | 'silver';
}

interface PriceTableRowProps {
  item: PriceItem;
}

const PriceTableRow = ({ item }: PriceTableRowProps) => {
  const { t } = useLanguage();

  return (
    <tr className="border-t border-border hover:bg-muted/50 transition-smooth">
      <td className="px-6 py-4 font-body text-sm text-foreground">{item.product}</td>
      <td className="px-6 py-4 font-body text-sm text-muted-foreground">{item.weight}</td>
      <td className="px-6 py-4 font-body text-sm text-muted-foreground">{item.purity}</td>
      <td className="px-6 py-4 font-body text-sm font-semibold text-accent">{item.ankauf}</td>
      <td className="px-6 py-4 font-body text-sm font-semibold text-accent">{item.verkaufNetto}</td>
      <td className="px-6 py-4 font-body text-sm font-semibold text-accent">{item.verkaufBrutto}</td>
      <td className="px-6 py-4">
        <CTAButton href="/contact" variant="primary" className="text-xs py-2 px-4 h-auto">
          {t('common.contactUs')}
        </CTAButton>
      </td>
    </tr>
  );
};

export default PriceTableRow;